// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { FunctionalComponent, h } from '@stencil/core';

import BonusCode from './BonusCode';
import NoFollowLink from './NoFollowLink';
import { FormattedPromotion } from '../../types';
import showTerms from '../../utils/terms';

interface FeaturedPromotionCardProps {
    promotion: FormattedPromotion;
    logPromotionClick: () => void;
    handleBonusCodeClick: () => void;
    bonusCodeWasClicked: boolean;
    promoCodeLabel?: string;
    noCodeLabel?: string;
    claimLabel?: string;
    seeMoreLabel?: string;
    specialOfferLabel?: string;
    terms?: 'geo' | 'affiliate';
}

const FeaturedPromotionCard: FunctionalComponent<FeaturedPromotionCardProps> = ({
    promotion,
    logPromotionClick,
    handleBonusCodeClick,
    bonusCodeWasClicked,
    promoCodeLabel,
    noCodeLabel,
    claimLabel,
    specialOfferLabel,
    terms = 'geo',
}) => {
    const termsText = promotion ? showTerms(promotion, terms) : '';

    const propMarfeelConversion = promotion?.link && promotion?.link.includes('switchboard') ? 'switchboard-click' : '';

    const claimPrefixRegex = /^claim\b\s*/i;

    function localizeClaimPrefix(text: string, label: string): string {
        if (!text || text === '-') {
            return text;
        }

        const match = text.match(claimPrefixRegex);
        if (!match) {
            return text;
        }

        const remainder = text.slice(match[0].length).trimStart();
        return remainder ? `${label} ${remainder}` : label;
    }

    const rawButtonText = promotion?.buttonText || '-';
    const buttonText = claimLabel ? localizeClaimPrefix(rawButtonText, claimLabel) : rawButtonText;

    return (
        <NoFollowLink class="featured-item font" onClick={logPromotionClick} href={promotion?.link}>
            <div>
                <div class="featured-item__content__header">
                    <span>{specialOfferLabel || 'Special Offer'}</span>
                </div>
                <div class="featured-item__content__container">
                    <div class="featured-item__content">
                        {promotion ? (
                            <lazy-load-logo
                                class="item__logo"
                                logo={promotion.logo}
                                promoId={promotion.id}
                                logoColor={promotion.logoColor}
                            />
                        ) : (
                            <div class="skeleton-item__logo"></div>
                        )}
                        <div class={`${promotion ? '' : 'skeleton-'}item__description`}>
                            <div class="featured-item__book-name">{promotion?.bookName}</div>
                            <div class="featured-item__cta">{promotion?.cta}</div>
                            <div class="featured-item__terms">{termsText}</div>
                        </div>
                    </div>
                    <div class="buttons">
                        <BonusCode
                            isFeatured={true}
                            bonusCode={promotion?.bonusCode}
                            bonusCodeWasClicked={bonusCodeWasClicked}
                            handleClick={handleBonusCodeClick}
                            labelText={promoCodeLabel}
                            noCodeLabel={noCodeLabel}
                        />
                        <div class="button button-font" data-mrf-conversion={propMarfeelConversion}>
                            {buttonText}
                        </div>
                    </div>
                </div>
            </div>
        </NoFollowLink>
    );
};

export default FeaturedPromotionCard;
